import { useGoogleMap } from '@react-google-maps/api';
import React from 'react';

import { StyledFullScreenIcon, StyledPressedFullScreenIcon } from './styles';
import { ControlPaper } from '../styles';

const FullScreenControl: React.FunctionComponent = (props): React.ReactElement | null => {
  const map = useGoogleMap();
  const [fullScreen, setFullScreen] = React.useState(false);

  const toggleFullScreen = (): void => {
    if (fullScreen) {
      document.exitFullscreen();
    } else {
      map?.getDiv().requestFullscreen();
    }
  };

  React.useEffect(() => {
    const updateFullScreen = (): void => setFullScreen(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', updateFullScreen);
    return () => {
      document.removeEventListener('fullscreenchange', updateFullScreen);
    };
  }, []);

  if (!map) {
    return null;
  }

  return (
    <ControlPaper elevation={6} {...props}>
      {fullScreen ? (
        <StyledPressedFullScreenIcon onClick={toggleFullScreen} />
      ) : (
        <StyledFullScreenIcon onClick={toggleFullScreen} />
      )}
    </ControlPaper>
  );
};

export default FullScreenControl;
